// Standard library imports
import React from 'react';
// Internal module imports
import TabsComponent from '../../../../../components/Tabs/Tabs';
import Capacity from './Capacity';
import Settlement from './Settlement';
import Price from './Price';
import BundleBidCapacity from './BundleBidCapacity';

const BiddingInfo = ({ data, bidType }) => {
    let tabs = [
        {
            name: 'Settlement (€)',
            component: (
                <>
                    <Settlement data={data.settlement} />
                </>
            ),
        },
        {
            name: 'Bidding Price (€)',
            component: (
                <>
                    <Price data={{ ...data.price, bidDate: data.bidDate }} />
                </>
            ),
        },
        {
            name: 'Bidding Capacity (MW)',
            component: (
                <>
                    {bidType === 'bundle' ? (
                        <BundleBidCapacity data={{ ...data.capacity, bidDate: data.bidDate }} />
                    ) : (
                        <Capacity data={{ ...data.capacity, bidDate: data.bidDate }} />
                    )}
                </>
            ),
        },
    ];

    return (
        <div className={'ventilation'} style={{ display: 'flex' }}>
            <TabsComponent selectedIndex={0} tabs={tabs} />
        </div>
    );
};

export default BiddingInfo;
